import type { AIFindResponse, PublicProductDto } from "./api/contracts";

export function flattenAIFindProducts(result: AIFindResponse): PublicProductDto[] {
  const rows = [
    ...(Array.isArray(result.products) ? result.products : []),
    ...((result.recognition?.status === "candidates" ? result.recognition.candidates : []) || [])
      .flatMap((candidate) => Array.isArray(candidate.products) ? candidate.products : []),
  ];
  const seen = new Set<string>();
  return rows.filter((row) => Boolean(row?.productKey) && !seen.has(row.productKey) && Boolean(seen.add(row.productKey)));
}

export function cleanAIFindQuery(value: unknown): string {
  const parts = String(value || "").trim().replace(/\s+/g, " ").split(/\s*[·|,，/]+\s*/).filter(Boolean);
  const seen = new Set<string>();
  return parts.filter((part) => {
    const key = part.toLocaleLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  }).join(" · ");
}

export function imageResultTitle(result: AIFindResponse, productCount: number): string {
  if (!productCount) return result.route === "personal_recommendation" ? "暂未找到合适的香水" : "暂未找到匹配商品";
  return result.recognition?.status === "candidates" ? "可能匹配的商品" : "搜索结果";
}
